import { render, staticRenderFns } from "./TtsTooManyButtonPressesRenderer.vue?vue&type=template&id=10fe4b1c"
import script from "./TtsTooManyButtonPressesRenderer.vue?vue&type=script&lang=js"
export * from "./TtsTooManyButtonPressesRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports